import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthGuard } from 'app/core/services/auth/auth-guard.service';
import {
  UsuarioPerfil,
  usuarioPerfilAdministrador
} from 'app/home/usuario/usuario-perfil';

export const acessosPeriodicidadeCompra: UsuarioPerfil[] = [
  usuarioPerfilAdministrador
];

@Injectable({
  providedIn: 'root'
})
export class PeriodicidadeCompraGuard implements CanActivate {
  constructor(private authGuard: AuthGuard) {}

  canActivate() {
    return this.authGuard.canActivateAcesso(acessosPeriodicidadeCompra);
  }
}
